import { themeAtom } from "../../shared/atoms";
import { Tab, Tabs } from "./VesselTabs";
import { CpTable } from "./tables/CpTable";
import { EcoTable } from "./tables/EcoTable";
import { InputTable } from "./tables/InputTable";
import { useAtomValue } from "jotai";
import { twMerge } from "tailwind-merge";

export function SpeedAndConsumption() {
  const theme = useAtomValue(themeAtom);
  return (
    <>
      <h1 className={twMerge("mb-1 pb-4 pt-4 text-lg font-bold", theme.home.tailwind.textDefault)}>
        Speed and consumption by contract
      </h1>

      <div className="" style={{ overflow: "visible" }}>
        <Tabs overflow="visible">
          <Tab label="Eco">
            <EcoTable />
          </Tab>

          <Tab label="CP">
            <CpTable />
          </Tab>

          <Tab label="Input">
            <InputTable />
          </Tab>
        </Tabs>
      </div>
    </>
  );
}
